import { ApolloClient, InMemoryCache } from "@apollo/client";
export const client = new ApolloClient({
 uri: "https://snowsurvey-worker.rcc-acis.workers.dev",
 headers: {},
 cache: new InMemoryCache(),
});